/**
 * Generated from HudLayout.fla
 */
export function HudLayout(this: IHudLayout) {
	const settingsButton = this.settingsButton;
	HudLayout_settingsButton.call(this.settingsButton);
	settingsButton.x = 1012.05;
	settingsButton.y = 730.2;
	settingsButton.width = 85.50;
	settingsButton.height = 90.90;
	if (settingsButton.onLayout) settingsButton.onLayout();
	const helpButton = this.helpButton;
	HudLayout_helpButton.call(this.helpButton);
	helpButton.x = 891;
	helpButton.y = 730.2;
	helpButton.width = 85.50;
	helpButton.height = 90.90;
	if (helpButton.onLayout) helpButton.onLayout();
	const homeButton = this.homeButton;
	HudLayout_homeButton.call(this.homeButton);
	homeButton.x = 9;
	homeButton.y = 72.8;
	homeButton.width = 85.50;
	homeButton.height = 90.90;
	if (homeButton.onLayout) homeButton.onLayout();
	const dwellToggleButton = this.dwellToggleButton;
	HudLayout_dwellToggleButton.call(this.dwellToggleButton);
	dwellToggleButton.x = 1014.55;
	dwellToggleButton.y = 112.05;
	dwellToggleButton.width = 103.26;
	dwellToggleButton.height = 58.28;
	if (dwellToggleButton.onLayout) dwellToggleButton.onLayout();
	const characterContainer = this.characterContainer;
	HudLayout_characterContainer.call(this.characterContainer);
	characterContainer.x = 81.5;
	characterContainer.y = 686.5;
	characterContainer.width = 143.50;
	characterContainer.height = 154.50;
	if (characterContainer.onLayout) characterContainer.onLayout();
	return this;
}
function HudLayout_settingsButton(this: IHudLayout_settingsButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-btn-large.png", 1.000, 1.000);
	return this;
}
function HudLayout_helpButton(this: IHudLayout_helpButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-help-btn-large.png", 1.000, 1.000);
	return this;
}
function HudLayout_homeButton(this: IHudLayout_homeButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-home-btn-large.png", 0.000, 0.000);
	return this;
}
function HudLayout_dwellToggleButton(this: IHudLayout_dwellToggleButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-splashscreen-dwell-off-btn.png", 1.000, 0.000);
	return this;
}
function HudLayout_characterContainer(this: IHudLayout_characterContainer) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flying-character-inez.png", 0.502, 0.515);
	return this;
}
interface IHudLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IHudLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IHudLayoutSprite extends IHudLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IHudLayoutText extends IHudLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IHudLayoutPolygon extends Array<number> {
}
interface IHudLayout {
	readonly settingsButton: IHudLayout_settingsButton;
	readonly helpButton: IHudLayout_helpButton;
	readonly homeButton: IHudLayout_homeButton;
	readonly dwellToggleButton: IHudLayout_dwellToggleButton;
	readonly characterContainer: IHudLayout_characterContainer;
}
interface IHudLayout_settingsButton extends IHudLayoutSprite {
}
interface IHudLayout_helpButton extends IHudLayoutSprite {
}
interface IHudLayout_homeButton extends IHudLayoutSprite {
}
interface IHudLayout_dwellToggleButton extends IHudLayoutSprite {
}
interface IHudLayout_characterContainer extends IHudLayoutSprite {
}
